import axios from "@/utils/request.js";
import qs from "qs"
// 新增 活动直播 
const activityAdd = (params) => axios({
    url: '/api/web-manager/live/activity/add',
    method: 'post',

    data: params
  })
//   直播 倒计时 功能开关
const activityButtonCountDown = (params) => axios({
    url: '/api/web-manager/live/activity/button/CountDown',
    method: 'post',

    data:params
  })

// 直播 打赏 功能开关
const activityButtonReward = (params) => axios({
  url: '/api/web-manager/live/activity/button/Reward',
  method: 'post',
  data: params
})

// 直播 垫片 功能开关
const activityUpdatePreFileFlag = (params) => axios({
  url: '/api/web-manager/live/activity/updatePreFileFlag',
  method: 'post',
  params
})

// 直播 垫片编辑
const activityUpdatePreFileById = (params) => axios({
  url: '/api/web-manager/live/activity/updatePreFileById',
  method: 'post',
  data: params
})
// 直播 回放 功能开关
const activityUpdatePlaybackFlag = (params) => axios({
  url: '/api/web-manager/live/activity/updatePlaybackFlag',
  method: 'post',
  params
})

// 直播 回放编辑
const activityUpdateRecord = (params) => axios({
  url: '/api/web-manager/live/activity/updateRecord',
  method: 'post',
  data: params
})

// 直播 点赞 功能开关
const activityLikeswich = (params) => axios({
  url: '/api/web-manager/live/activity/button/likeswich',
  method: 'post',
  params
})
// 直播 点赞 功能开关
const activityWhiteswich = (params) => axios({
  url: '/api/web-manager/live/activity/button/whiteswich',
  method: 'post',
  params
})

// 直播 点赞 修改基础人数
const activityLikebase = (params) => axios({
  url: '/api/web-manager/live/activity/likebase',
  method: 'post',
  params
})
// 直播 点赞 获取点赞人数
const activityGetLike = (params) => axios({
  url: '/api/web-manager/live/activity/getlike',
  method: 'get',
  params
})

// 添加一条点赞
const activityLike = (params) => axios({
  url: '/api/web-manager/live/activity/like',
  method: 'post',
  params
})
// 开启直播
const liveBroadcastSwich = (params) => axios({
  url: '/api/web-manager/live/activity/swich',
  method: 'post',
  data: qs.stringify(params)
})

// 活动批量删除
const activityDelete = (params) => axios({
  url: '/api/web-manager/live/activity/delete',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 白名单添加
const activityWhiteuserAdd = (params) => axios({
  url: '/api/web-manager/live/whiteuser/add',
  method: 'post',
  data: params
})
// 白名单删除
const activityWhiteuserDelete = (params) => axios({
  url: '/api/web-manager/live/whiteuser/delete',
  method: 'post',
  data: qs.stringify(params)
})
// 查找白名单用户
const activityWhiteuserPage = (params) => axios({
  url: '/api/web-manager/live/whiteuser/page',
  method: 'get',
  params
})

// 获取用户列表
const userManagerAll = (params) => axios.get('/api/web-conf/user/manager/list', {
  params
})

// 根据id删除活动画面
const activityFrame = (params) => axios({
    url: '/api/web-manager/live/activity/frame',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
  
// 直播详情页面
const activityDetail = (params) => axios.get('/api/web-manager/live/activity/allInfo', {
    params
})
// 直播详情页面
const activityDetailNotoken = (params) => axios.get('/api/web-manager/live/activity/allInfonotoken', {
  params
})
// 查询直播运营开关
const activityButton = (params) => axios.get('/api/web-manager/live/activity/button', {
    params
})

// 节目直播
const activityPage = (params) => axios.get('/api/web-manager/live/activity/page', {
    params
})
// 查询活动直播观众人数
const  activityPeople = (params) => axios.get('/api/web-manager/live/activity/people', {
    params
})
// 更新活动直播状态
const activityUpdate = (params) => axios({
    url: '/api/web-manager/live/activity/update',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
// 超级编辑
const activitySuper = (params) => axios({
    url: '/api/web-manager/live/activity/super',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
  // 观众人数设置
const activitySetPeople = (params) => axios({
    url: '/api/web-manager/live/activity/people',
    method: 'post',
    data: params
  })
  
//   根据id查询活动人数信息
const activitypeopleInfo = (params) => axios.get('/api/web-manager/live/activity/people/info', {
    params
})
// 新增直播推荐
const activityInsertrecommend = (params) => axios({
  url: '/api/web-manager/live/activity/insertrecommend',
  method: 'post',
  data: params
})
// 删除直播推荐 
const activityDeleterecommend = (params) => axios({
  url: '/api/web-manager/live/activity/deleterecommend',
  method: 'post',
  data: qs.stringify(params)
})
// 置顶直播推荐 
const activityTopRcommend = (params) => axios({
  url: '/api/web-manager/live/activity/toprecommend',
  method: 'post',
  data: qs.stringify(params)
})

// 节目直播推荐
const activityGetRecommend = (params) => axios.get('/api/web-manager/live/activity/getrecommend', {
  params
})
// 自增同问

const forbiddenuserAddCount = (params) => axios.get('/api/web-manager/live/forbiddenuser/addcount', {
  params
})
// 自减同问

const forbiddenuserMinuscount = (params) => axios.get('/api/web-manager/live/forbiddenuser/minuscount', {
  params
})


// 获取活动直播在线人数
const getPeople = (params) => axios.get('/api/web-manager/message/manager/live/people', {
  params
})

// 获取评论所有聊天
const getCommentQuery = (params) => axios.get('/api/web-manager/live/comment/query', {
  params
})

// 评论审核
const activityCommentexamine = (params) => axios({
  url: '/api/web-manager/live/comment/commentexamine',
  method: 'post',
  data: qs.stringify(params)
})
// 评论置顶
const activityCommentTop = (params) => axios({
  url: '/api/web-manager/live/comment/commenttop',
  method: 'post',
  data: qs.stringify(params)
})

// 删除聊天 
const activityCommentDelete = (params) => axios({
  url: '/api/web-manager/live/comment/delete',
  method: 'post',
  data: qs.stringify(params)
})

// 根据ID查询单个慢直播频道
const livetrafficPreviewNotoken= (params) => axios({
  url: '/api/web-manager/live/livetraffic/previewnotoken',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
export {
    activityAdd,
    activityButtonCountDown,
    activityButtonReward,
    activityDelete,
    activityDetail,
    activityFrame,
    activityButton,
    activityPage,
    activityPeople,
    activityUpdate,
    activitySuper,
    activitySetPeople,
    activitypeopleInfo,
    activityDetailNotoken,
    activityInsertrecommend,
    activityDeleterecommend,
    activityGetRecommend,
    forbiddenuserAddCount,
    forbiddenuserMinuscount,
    getPeople,
    activityTopRcommend,
    getCommentQuery,
    activityCommentexamine,
    activityCommentDelete,
    activityCommentTop,
    activityUpdatePreFileFlag,
    activityUpdatePreFileById,
    activityUpdatePlaybackFlag,
    activityUpdateRecord,
    activityLikeswich,
    activityLikebase,
    activityLike,
    activityGetLike,
    activityWhiteswich,
    userManagerAll,
    activityWhiteuserAdd,
    activityWhiteuserPage,
    activityWhiteuserDelete,
    liveBroadcastSwich,
    livetrafficPreviewNotoken,
}